import Person from "./Person";
import CartItem from "./CartItem";
import uuidv4 from 'uuid/v4';

export default class PersonAddItem extends Person {
  preposalId;
  itemId;
  sku;
  quantity;
  slideshowDigest;
  pageDigest;

  constructor(preposalId, sku, quantity, slideshowDigest, pageDigest) {
    super();

    this.preposalId = preposalId;
    this.itemId = uuidv4();
    this.sku = sku;
    this.quantity = quantity;
    this.slideshowDigest = slideshowDigest;
    this.pageDigest = pageDigest;
  }

  process(cart, productBySku) {
    var newItem = new CartItem(null, this, productBySku);
    cart.items.push(newItem);
  }
  toDto() {
    return {
      spa_passenger_dto_type: "item-add",
      spa_passenger_dto_add_item:
      {
        spa_passenger_add_item_dto_preposal_id: this.preposalId,
        spa_passenger_add_item_dto_item_id: this.itemId,
        spa_passenger_add_item_dto_sku: this.sku,
        spa_passenger_add_item_dto_quantity: this.quantity,
        spa_passenger_add_item_dto_slideshow_digest: this.slideshowDigest,
        spa_passenger_add_item_dto_page_digest: this.pageDigest
      }
    }
  }
}
